<span revTooltip [tooltipContent]="getTooltipText()">
	<i [class]="'fa app-status-icon fa-comments ' + getColorClass()"></i>
</span>
